import clsx from 'clsx'
import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'

import {
  TableHeader,
  TableHeaderItem,
  TablePelaksanaanKinerja,
  TableBody,
  TableRow,
  TableRowItem,
  TableShimmer,
} from 'app/KinerjaShared/components/TablePelaksanaanKinerja'
import PlanningApprovalBadge from 'app/KinerjaTimPenilaiPenilikPage/components/PlanningApprovalBadge'
import StateEmpty from 'app/KinerjaShared/components/StateEmpty'
import { PENGELOLAAN_KINERJA_BASE_PATH } from 'app/KinerjaShared/constants/path'
import useBasePath from 'app/KinerjaTimPenilaiPenilikPage/hooks/useBasePath'

import type { PerencanaanPenilik } from 'types/kinerja-tim-penilai-penilik'
import type { StatusPerencanaan } from 'types/kinerja-penilik-pegawai'

type Props = {
  data: PerencanaanPenilik[]
  isLoading?: boolean
  className?: string
  basePath?: string
  isBulkApproval?: boolean
  openInNewTab?: boolean
}

export default function TablePerencanaanPenilik({
  data,
  isLoading = false,
  className,
  basePath = PENGELOLAAN_KINERJA_BASE_PATH,
  isBulkApproval = false,
  openInNewTab = false,
}: Props) {
  const isEmpty = data.length === 0
  const { isPPKPenilikUrl } = useBasePath()

  const canBeEvaluated = (state: StatusPerencanaan) => {
    const states: StatusPerencanaan[] = [
      'SEDANG_DIPERIKSA',
      ...(isPPKPenilikUrl ? (['DIKIRIM_TK'] as StatusPerencanaan[]) : []),
    ]
    return states.includes(state)
  }

  return (
    <TablePelaksanaanKinerja className={className} fullWidth>
      <TableHeader>
        <TableHeaderItem>Nama</TableHeaderItem>
        <TableHeaderItem>Status</TableHeaderItem>
        <TableHeaderItem></TableHeaderItem>
      </TableHeader>
      <TableBody>
        {isLoading && <TableShimmer />}
        {!isLoading &&
          (isEmpty ? (
            // if no data found for certain state
            <TableRow>
              <TableRowItem colSpan={3}>
                <StateEmpty>
                  Pastikan terdapat Perencanaan dengan status tersebut
                </StateEmpty>
              </TableRowItem>
            </TableRow>
          ) : (
            // if data exists
            data.map((data) => (
              <TableRow
                data-testid="perencanaan-row"
                key={data.skpId}
                className={clsx(
                  (data.status === 'DISETUJUI_PPK' ||
                    data.status === 'PELAKSANAAN_DIMULAI') &&
                    'bg-surface-success-subdued'
                )}
              >
                <TableRowItem className="w-[332px]">
                  {data.namaPenilik}
                </TableRowItem>
                <TableRowItem>
                  <PlanningApprovalBadge state={data.status} />
                </TableRowItem>
                <TableRowItem className="text-right w-[100px]">
                  {data.status !== 'MULAI_PERENCANAAN' &&
                    data.status !== 'SIAP_DIAJUKAN' && (
                      <Link
                        passHref
                        href={`${basePath}/perencanaan/${data.skpId}/detail${
                          isBulkApproval ? '?from=BULK_APPROVAL' : ''
                        }`}
                      >
                        <Button
                          as="a"
                          color={
                            canBeEvaluated(data.status) ? 'black' : 'white'
                          }
                          className={clsx(
                            '!inline-flex',
                            !canBeEvaluated(data.status) && '!bg-transparent'
                          )}
                          size="sm"
                          target={openInNewTab ? '_blank' : undefined}
                        >
                          {canBeEvaluated(data.status) ? 'Periksa' : 'Cek'}
                        </Button>
                      </Link>
                    )}
                </TableRowItem>
              </TableRow>
            ))
          ))}
      </TableBody>
    </TablePelaksanaanKinerja>
  )
}
